import React, { Component } from "react";

export class MasterActionCellRenderer extends Component {
    render() {
        const { data, onSelect, idField } = this.props;
        if (!data || !onSelect || !idField) {
            return null;
        }
        return (
            <div className="text-center table-action-button" title="Select" style={{ cursor: "pointer" }} onClick={() => onSelect(data[idField])}>
                <i className="fa-solid fa-pen-to-square"></i>
            </div>
        );
    }
}

export class MasterActiveCellRenderer extends Component {
    render() {
        const value = this.props.value;
        return (
            <div className="text-center">
                {value ? (
                    <i className="fa-regular fa-square-check"></i>
                ) : (
                    <i className="fa-regular fa-square"></i>
                )}
            </div>
        );
    }
}

export const formatGridAmount = (params) => {
    const value = params.value;
    return value != null ? Number(value).toFixed(2) : "0.00";
};

export const createMasterActionColumn = (onSelect, idField) => ({
    headerName: "Select",
    colId: "actions",
    sortable: false,
    filter: false,
    floatingFilter: false,
    resizable: false,
    width: 90,
    flex: 0,
    suppressSizeToFit: true,
    pinned: "left",
    cellClass: "text-center table-action-cell",
    headerClass: "text-center",
    cellRenderer: MasterActionCellRenderer,
    cellRendererParams: { onSelect, idField },
});

export const createMasterActiveColumn = () => ({
    headerName: "Active",
    field: "IsActive",
    width: 90,
    sortable: false,
    filter: false,
    floatingFilter: false,
    cellClass: "text-center",
    cellRenderer: MasterActiveCellRenderer,
});
